import type { } from '@mui/lab/themeAugmentation';
import { createTheme, Theme } from '@mui/material/styles';

// eslint-disable-next-line import/no-mutable-exports
let AppTheme: Theme;

const getAppTheme = () => AppTheme;

const createAppTheme = (shadowRootElement?: Element | (() => Element | null) | null | undefined) => {
  AppTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      primary: {
        main: '#046fa8',
        light: 'rgba(255, 255, 255, 0.87)',
        dark: '#046fa8',
      },
      secondary: {
        main: '#c1c1c2',
        light: 'rgba(255, 255, 255, 0.13)',
        dark: '#616161',
      },
      info: {
        main: 'rgba(255, 255, 255, 0.87)',
      },
      lightPlan: {
        main: 'rgba(255, 255, 255, 1)',
        dark: '#94D5F8',
      },
      mainBackground: {
        main: '#E6EDF3',
        contrastText: '#000000',
      },
      altBackground: {
        main: '#046fa8',
        dark: 'rgba(4, 71, 129, 0.65)',
        contrastText: '#FDCE0D',
      },
      bluePlan: {
        main: '#0585c8',
        contrastText: '#ffffff',
        light: 'rgba(70, 211, 230, 1)',
        dark: '#046FA8',
      },
      yellowPlan: {
        main: '#fcb119',
        contrastText: '#ffffff',
        light: 'rgba(254, 227, 96, 1)',
        dark: '#AD5B07',
      },
      greenPlan: {
        main: '#74c045',
        contrastText: '#ffffff',
        dark: '#2F7404',
      },
      goldPlan: {
        main: '#fde500',
        dark: '#a49500',
      },
      charts: {
        redChart: '#fcb119',
        blueChart: '#0585c8',
        greenChart: '#74c045',
        greyChart: '#636466',
        yellowChart: '#FDCE0D',
        clearChart: 'rgb(255,255,255,0)',
      },
      error: {
        main: '#d32f2f',
      },
      tab: {
        underline: 'rgba(254, 227, 96, 1)',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            padding: '0 50px',
          },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            minHeight: 55,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 15,
          },
        },
      },
      MuiLoadingButton: {
        defaultProps: {
          loadingPosition: 'start',
        },
      },
      MuiPopover: {
        defaultProps: {
          container: shadowRootElement,
        },
      },
      MuiPopper: {
        defaultProps: {
          container: shadowRootElement,
        },
      },
      MuiModal: {
        defaultProps: {
          container: shadowRootElement,
        },
      },
    },
  });

  return AppTheme;
};

const mapPlanToPalette = (plan: string) => {
  switch (plan) {
    case 'RD1':
    case 'GD1':
    case '427':
    case '707':
      return 'bluePlan';
    case 'RG1':
    case 'GS1':
    case '400':
    case '600':
      return 'yellowPlan';
    case 'RG5':
    case 'GS3':
    case '407':
    case '607':
      return 'greenPlan';
    case '507':
      return 'goldPlan';
    default:
      return 'secondary';
  }
};

export { getAppTheme, createAppTheme, mapPlanToPalette };
